//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SMSTemplateType } from './Enums';

export class SMSPreviewInputItem extends ItemBase {
    TemplateType: SMSTemplateType = SMSTemplateType.Reminder;
    BodyWithPlaceholders: string | null = null;
    IgnorePlaceholderErrors: boolean = false;
    IgnoreLengthLimit: boolean = false;

    constructor(initializer?: Partial<SMSPreviewInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SMSPreviewInputItem";
}
